module.exports = __webpack_public_path__ + "img/zgcls.b019e21d.png";